import a from '@/utils/axios/axios'

const analysis = {
  namespaced: true,
  state: () => ({
    events: [],
    creating_event: null,
    modifying_event_id: null,
    game_state: {
      hitting_number_home: 1,
      hitting_number_away: 1
    },
    points: [],
    show_measure_tape: false,
    mouse_position: { x: 0, y: 0 },
    predicting_hit_type: false,
    events_filter_function: null
  }),
  mutations: {
    SET_SHOW_MEASURE_TAPE(state, val) {
      state.show_measure_tape = val
    },
    SET_CREATING_EVENT_SILENT(state, val) {
      state.creating_event = { ...val, silent: true }
    },
    SET_CREATING_EVENT(state, val) {
      state.creating_event = { ...val, silent: false }
    },
    REMOVE_CREATING_EVENT(state) {
      state.creating_event = null
    },
    SET_EVENT_SILENT(state, val) {
      const i = state.events.findIndex(e => e.event_id === val.event_id)
      let mod = [ ...state.events ]
      if(i === -1) return
      mod[i] = { ...val, silent: true }
      state.events = mod
    },
    SET_EVENT(state, val) {
      const i = state.events.findIndex(e => e.event_id === val.event_id)
      let mod = [ ...state.events ]
      if(i === -1) return
      mod[i] = { ...val, silent: true }
      state.events = mod
    },
    ADD_EVENT(state, val) {
      state.events = [...state.events].concat(val)
    },
    SET_EVENTS(state, val) {
      state.events = val
    },
    LOADING_EVENTS(state, val) {
      state.loading_events = val
    },
    SET_MODIFYING_EVENT_ID(state, val) {
      state.modifying_event_id = val
    },
    ADD_POINT(state, val) {
      state.points = [...state.points].concat([val])
    },
    SET_MOUSE_POSITION(state, { x, y }) {
      state.mouse_position = { x, y }
    },
    PREDICTING_HIT_TYPE(state, val) {
      state.predicting_hit_type = val
    },
    SET_EVENTS_FILTER_FUNCTION(state, val) {
      state.events_filter_function = val
    }
  },
  actions: {
    pointClicked({ commit }, point) {
      commit('ADD_POINT', point)
    },
    mouseMoved({ commit }, point) {
      commit('SET_MOUSE_POSITION', { x: parseFloat(point[0]), y: parseFloat(point[1]) })
    },
    createEvent({ commit, dispatch }, event) {
      commit('ADD_EVENT', event)

      return new Promise((resolve, reject) => {
        dispatch('postEvent', { event })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    updateEvent({ commit, dispatch }, { event, updateRunTime, updatePlayTime }) {
      return new Promise((resolve, reject) => {
        dispatch('postEvent', { event, updateRunTime, updatePlayTime })
          .then(res => {
            resolve(res)
            commit('SET_EVENT', res)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    startEditingEvent({ getters, commit }, event_id) {
      commit('SET_CREATING_EVENT', getters.events.find(e => e.event_id === event_id))
    },
    deleteEvent({ commit, getters }, event_id) {
      return new Promise((resolve, reject) => {
        a.delete(`/event/${event_id}`)
          .then(res => {
            commit('SET_EVENTS', getters.events.filter(e => e.event_id !== event_id))
            commit('REMOVE_CREATING_EVENT')
            resolve(res)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    getGameEvents({ commit }, game_id) {
      commit('LOADING_EVENTS', true)
      commit('SET_EVENTS', [])
      return new Promise((resolve, reject) => {
        a.get(`/event/game/${game_id}`)
          .then(res => {
            commit('SET_EVENTS', res.data)
            resolve(res.data)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
          .finally(() => {
            commit('LOADING_EVENTS', false)
          })
      })
    },
    setEventPropertySilently({ dispatch }, payload) {
      return dispatch('setEventProperty', {
        ...payload,
        silent: true
      });
    },
    setEventProperty({ commit, getters }, { val, path, null_if_chosen, silent = false }) {
      // Validate the path parameter
      if (!path) {
        console.error("Path is required to set a property.");
        return;
      }

      // Deep copy of the object
      let mod = getters.modifying_event_id
        ? JSON.parse(JSON.stringify(getters.modifying_event))
        : JSON.parse(JSON.stringify(getters.creating_event));

      const props = path.split('.');
      let current = mod;

      // Traverse through the path except the last property
      for (let i = 0; i < props.length - 1; i++) {
        const prop = props[i];
        if (!current[prop] || typeof current[prop] !== 'object') {
          current[prop] = {};
        }
        current = current[prop];
      }

      // Get the current value at the final property
      const finalProp = props[props.length - 1];
      const currentValue = current[finalProp];

      // Set the value at the final property based on null_if_chosen
      if (null_if_chosen && currentValue === val) {
        current[finalProp] = null;  // Set to null if the current value matches the incoming value
      } else {
        current[finalProp] = val;   // Otherwise, set to the incoming value
      }

      // Commit the modified event using either silent or normal mutation
      if (getters.modifying_event_id) {
        commit(silent ? 'SET_EVENT_SILENT' : 'SET_EVENT', mod);
      } else {
        commit(silent ? 'SET_CREATING_EVENT_SILENT' : 'SET_CREATING_EVENT', mod);
      }

      return mod
    },
    postEvent(_, { event, updateRunTime, updatePlayTime}) {
      return new Promise((resolve, reject) => {
        a.post('/event', { event, updateRunTime, updatePlayTime})
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    openPreviousEvent({ dispatch, getters }) {
      const curr = getters.current_event
      if(!curr || !curr.event_id) return

      let new_i
      let i = getters.events.findIndex(e => e.event_id === curr.event_id)
      if(i === -1) return
      if(i === 0) new_i = getters.events.length - 1
      else new_i = i - 1

      const new_event = getters.events[new_i]
      const new_event_id = new_event.event_id
      dispatch('startEditingEvent', new_event_id)
      dispatch('player/seek', Math.max(new_event.starttime - 2, 0), { root: true })
    },
    openNextEvent({ dispatch, getters }) {
      const curr = getters.current_event
      if(!curr || !curr.event_id) return

      let new_i
      let i = getters.events.findIndex(e => e.event_id === curr.event_id)
      if(i === -1) return
      if(i === getters.events.length - 1) new_i = 0
      else new_i = i + 1

      const new_event = getters.events[new_i]
      const new_event_id = new_event.event_id
      dispatch('startEditingEvent', new_event_id)
      dispatch('player/seek', Math.max(new_event.starttime - 2, 0), { root: true })
    },
    predictType({ commit }, data) {
      commit('PREDICTING_HIT_TYPE', true)
      return new Promise((resolve, reject) => {
        a.post('/predict/hit', data)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
          .finally(() => {
            commit('PREDICTING_HIT_TYPE', false)
          })
      })
    }
  },
  getters: {
    events: state => {
      if(state.events_filter_function) {
        return state.events.filter(state.events_filter_function)
      }

      return state.events
    },
    predicting_hit_type: state => state.predicting_hit_type,
    loading_events: state => state.loading_events,
    modifying_event_id: state => state.modifying_event_id,
    mouse_position: state => state.mouse_position,
    creating_event: state => state.creating_event,
    show_measure_tape: state => state.show_measure_tape,
    modifying_event: state => {
      if(!state.events || !state.events.length) return {}
      return state.events.find(event => event.event_id === state.modifying_event_id) || null
    },
    current_event: (state, getters) => {
      return state.creating_event || getters.modifying_event || {}
    },
    points: state => state.points
  }
}

export default analysis